import { useBiLogger } from '@wix/cli-telemetry-react';
import { useMemo } from 'react';
import { createAppBiEvents } from './events.js';

export function useCreateAppBi() {
  const biLogger = useBiLogger();

  return useMemo(() => createAppBiEvents(biLogger), [biLogger]);
}
